import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CardForm from "./pages/CardForm";
import CardDetail from "./pages/CardDetail";
import PublicCard from "./pages/PublicCard";
import SharedContacts from "./pages/SharedContacts";
import Analytics from "./pages/Analytics";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/card/:uniqueId" element={<PublicCard />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cards"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cards/new"
            element={
              <ProtectedRoute>
                <CardForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cards/:cardId/edit"
            element={
              <ProtectedRoute>
                <CardForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cards/:cardId"
            element={
              <ProtectedRoute>
                <CardDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shared-contacts"
            element={
              <ProtectedRoute>
                <SharedContacts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
